import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { ContratAEditerDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAEditerDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalListeSalarie extends Vue {
	public demande?: DemandeEditionTableauDto;
	public salaries: ContratAEditerDto[] = [];
	public dataReady = false;

	public initSalaries(): void {
    	this.salaries = [];
    	this.dataReady = true;
    	if (this.demande == undefined) {
			return;
		}
    	ServicesFactoryInstance.CalculPaieService.GetContratAEditer(
    		this.demande.AnneeDebut,
    		this.demande.MoisDebut,
    		this.demande.AnneeFin,
    		this.demande.MoisFin,
    		data => {
    			this.salaries = data.sort((a, b) => (a.FullName != undefined && b.FullName != undefined && a.FullName.toLowerCase() > b.FullName.toLowerCase()) ? 1 : -1);
    			this.dataReady = true;
    			for (let i = 0; i < this.salaries.length; i++) {
    				(this.salaries[0] as any).selected = false;
    			}
    		});

    	this.$forceUpdate();
	}

	public LancerEdition(): void {
    	if (this.demande != undefined) {
			for (let i = 0; i < this.salaries.length; i++) {
    			const salarie: any = this.salaries[i];
    			if (salarie.selected) {
					this.demande.IdsContrat.push(salarie.IdContrat);
				}
			}

			if (this.demande.CodeTypeTableau == "J") {
				this.$emit("openJournal", this.demande);
			} else if (this.demande.CodeTypeTableau == "D") {
				this.$emit("openDeclarationCharges", this.demande);
			} else {
				NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

				ServicesFactoryInstance.EditionsService.getEditionTableau(this.demande, (r: Blob) => {
					if (this.demande == undefined) {
						return;
					}

					const libelle = this.demande.libelleEdition + (this.demande.CodeTypeTableau == "B" ? ".docx" : (this.demande.exportExcel ? ".xlsx" : ".pdf"));

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(r, libelle);
					} else {
						const link = document.createElement("a");
						document.body.appendChild(link);

						link.href = window.URL.createObjectURL(r);
						link.download = libelle;
						link.click();

						NotificationServiceInstance.SendSuccess("L'édition de la liste '" + this.demande.libelleEdition + "' s'est correctement déroulée !");
					}
				});
			}
    	}
    	$("#modalListeSalarie").modal("hide");
	}

	public annuler(): void {
		$("#modalListeSalarie").modal("hide");
	}

	public initEdition(demande: DemandeEditionTableauDto): void {
    	this.demande = demande;
    	this.initSalaries();
	}

	public click_check(target: any): void {
    	const element: HTMLElement = document.getElementById(target) as HTMLElement;
    	element.click();
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalListeSalarie/modalListeSalarie.ts